import React, { useState } from 'react';
import { FaChevronUp } from 'react-icons/fa';
import { MdOutlineKeyboardArrowLeft } from 'react-icons/md';
import { Helmet } from 'react-helmet';
import '../index.css';
import Evaluate from "./../image/process/1.png";
import Recruitment from "./../image/process/2.png";
import Review from "./../image/process/3.png";
import Screening from "./../image/process/4.png";
import Resume from "./../image/process/5.png";
import Interview from "./../image/process/6.png";

const processSteps = [
  { id: 1, name: "Evaluate Requirement", content: `The \"Evaluate Requirement\" step focuses on understanding the role's needs...`, image: Evaluate },
  { id: 2, name: "Recruitment Plan", content: "The recruitment plan outlines the strategy...", image: Recruitment },
  { id: 3, name: "Review Applicants", content: `During the review stage, applications are evaluated...`, image: Review },
  { id: 4, name: "Pre-Screening", content: `Pre-screening involves quickly assessing candidates...`, image: Screening },
  { id: 5, name: "Resume Submittal", content: `In the resume submittal stage...`, image: Resume },
  { id: 6, name: "Interview Feedback", content: `After the interviews, feedback is collected...`, image: Interview}
];

const Process = ({ title }) => {
  const [activeStep, setActiveStep] = useState(1);
  const [openStep, setOpenStep] = useState(null);

  const toggleOpen = (id) => {
    setOpenStep(openStep === id ? null : id);
    setActiveStep(id);
  };

  return (
    <div className="w-full max-w-[1400px] px-4 lg:p-0 p-4 mx-auto mt-5 border-b border-[#cacbd1]">
      <Helmet>
        <title>Our Process - Nexify Infosystems</title>
      </Helmet>
      <div className="flex flex-col lg:flex-row overflow-hidden mt-10">
        {/* Left Side */}
        <div className="w-full lg:w-1/2 bg-white text-black lg:p-10 p-4 overflow-y-auto scrollbar-hide">
          <h1 className="text-[30px] md:text-[50px] lg:text-[62px] text-[#0a0a0a] font-[700] leading-[1.2] mb-6">
            Our Comprehensive Process <span className='text-[#0e55a8]'> for Ensuring Client </span> Satisfaction
          </h1>
          <p className="mb-6 text-[#363638] text-[18px] leading-[1.6] font-[500]">
            We have a streamlined process to swiftly meet our clients' specific needs.
          </p>

          {processSteps.map((step) => (
            <div key={step.id} className="mb-4 border-b border-[#cacbd1]" style={{ padding: '20px 0' }}>
              <div
                className={`cursor-pointer flex justify-between items-center text-lg font-semibold ${openStep === step.id ? 'text-[#0e55a8]' : 'text-[#363638]'}`}
                onClick={() => toggleOpen(step.id)}
              >
                <div className={`flex text-[22px] font-[600] items-center gap-3 ${openStep === step.id ? 'text-[#0e55a8]' : 'text-[#363638]'}`}>
                  Process #{step.id} – {step.name}
                </div>
                <span className={`${openStep === step.id ? 'text-[#0e55a8]' : 'text-black'}`}>
                  {openStep === step.id ? <FaChevronUp /> : <MdOutlineKeyboardArrowLeft />}
                </span>
              </div>
              {openStep === step.id && (
                <p className="mt-3 text-[#6d6d70] text-[18px] font-[400] leading-[1.6]">
                  {step.content}
                </p>
              )}
            </div>
          ))}
        </div>

        {/* Right Side Image */}
        <div className="w-full lg:w-1/2 bg-white p-10 flex justify-center items-center overflow-hidden">
          <img
            src={processSteps[activeStep - 1]?.image}
            alt={processSteps[activeStep - 1]?.name}
            className="w-full h-full object-cover rounded-lg shadow-lg transition-all duration-300"
          />
        </div>
      </div>
    </div>
  );
};

export default Process;
